export const environment = {
  production: false,
  testMode: true,
  baseUrl: 'https://development-api.aqt.mpsa.com/admin',
  authUrl: 'https://development.aqt.mpsa.com/bo/auth'
};
